import React, { FC, useEffect, useState } from 'react';
import { Link, Typography } from '@loomstateorg/shared-frontend';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';

export interface Props {
  link: string;
  linkName: string;
  typographyClassName?: string;
  index?: number;
  children?: React.ReactNode;
}

const HeaderNavigationButtonDesktop: FC<Props> = ({
  link,
  linkName,
  typographyClassName = 'text-16 font-primaryBold 2xl:text-18',
  index = 0,
}) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const navLinkClassNames = useClassNames([
    'flex border-primary-regular py-4 cursor-pointer relative hover:underline hover:underline-offset-4 decoration-2 hover:decoration-primary-regular',
  ]);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  if (!isLoaded) return <></>;

  return (
    <div className="h-52 px-10 py-12 2xl:px-12">
      <Link link={link} title={linkName} className={navLinkClassNames} data-testid={`nav-category-${index}`}>
        <Typography className={typographyClassName}>{linkName}</Typography>
      </Link>
    </div>
  );
};
export default HeaderNavigationButtonDesktop;
